export class ZohoValueEntity {
  zohoBooksServiceDiscountItemId?: string | null
  zohoBooksBranchDiscountItemId?: string | null
  zohoBooksFastPayItemId?: string | null
  zohoBooksNassWalletItemId?: string | null
  zohoBooksFibItemId?: string | null
  zohoBooksAqsatiItemId?: string | null
  zohoBooksAqsatiCommissionItemId?: string | null
  zohoBooksPaymentFeeItemId?: string | null
  zohoBooksServiceFeeItemId?: string | null
  zohoBooksServiceDeliveryFeeItemId?: string | null
  zohoBooksBranchDeliveryFeeItemId?: string | null
  zohoBooksNotDeliveredOrderItemId?: string | null
  zohoBooksAgentServiceDiscountItemId?: string | null
  zohoBooksAgentBranchDiscountItemId?: string | null
  zohoBooksVatItemId?: string | null
  zohoBooksSalesAccountId?: string | null
  zohoBooksFreeDeliveryBranchShareAccountId?: string | null
  zohoBooksFreeDeliveryServiceShareAccountId?: string | null
  zohoBooksPettyCashAccountId?: string | null
  zohoBooksBranchCashAccountId?: string | null
  zohoBooksCampaignServiceDiscountAccountId?: string | null
  zohoBooksCampaignBranchDiscountAccountId?: string | null
  zohoBooksPurchaseAccountId?: string | null
  zohoBooksInventoryAccountId?: string | null
  zohoBooksCustomerWalletAccountId?: string | null
  zohoBooksPackageDeliveryItemId?: string | null
  zohoBooksPackageServiceFeeItemId?: string | null
  zohoBooksPackageInvoiceSalesAccountId?: string | null
  zohoBooksCashbackFibShareAccountId?: string | null
  zohoBooksCashbackFibShareItemId?: string | null
  zohoBooksCashbackNassWalletShareAccountId?: string | null
  zohoBooksCashbackNassWalletShareItemId?: string | null
  zohoBooksCashbackFastPayShareAccountId?: string | null
  zohoBooksCashbackFastPayShareItemId?: string | null
  zohoBooksCashbackQiCardShareAccountId?: string | null
  zohoBooksCashbackQiCardShareItemId?: string | null
  zohoBooksCashbackAqsatiShareAccountId?: string | null
  zohoBooksCashbackAqsatiShareItemId?: string | null
  zohoBooksCashbackZainCashShareAccountId?: string | null
  zohoBooksCashbackZainCashShareItemId?: string | null
  zohoBooksCashbackAsiaPayShareAccountId?: string | null
  zohoBooksCashbackAsiaPayShareItemId?: string | null
}
